// import axios from 'axios';
// import { BASE_URL, SUB_URL_KanbanPlanSheet } from './BaseUrl';

// const API_BASE_URL = `${BASE_URL.BASE_URL}${BASE_URL.API_URL}`;

// // Get active items
// export const getActiveItems = async () => {
//   try {
//     const formData = new FormData();
//     const response = await axios.post(`${API_BASE_URL}${SUB_URL_KanbanPlanSheet.get_active_items}`, formData);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching active items:', error);
//     throw error;
//   }
// };

// // Get style numbers by item number
// export const getStyleNumbers = async (itemNo) => {
//   try {
//     const formData = new FormData();
//     formData.append('item_no', itemNo);
//     const response = await axios.post(`${API_BASE_URL}${SUB_URL_KanbanPlanSheet.get_style_no_by_item_no}`, formData);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching style numbers:', error);
//     throw error;
//   }
// };

// // Get PO numbers by style number
// export const getPONumbers = async (styleNo) => {
//   try {
//     const formData = new FormData();
//     formData.append('style_no', styleNo);
//     const response = await axios.post(`${API_BASE_URL}${SUB_URL_KanbanPlanSheet.get_po_no_by_style_no}`, formData);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching PO numbers:', error);
//     throw error;
//   }
// };

// // Get colors by PO number
// export const getColors = async (poNo) => {
//   try {
//     const formData = new FormData();
//     formData.append('po_no', poNo);
//     const response = await axios.post(`${API_BASE_URL}${SUB_URL_KanbanPlanSheet.get_color_by_po_no}`, formData);
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching colors:', error);
//     throw error;
//   }
// };

// // Get Kanban details for sorting
// export const getKanbanDetailsForSorting = async (filters) => {
//   try {
//     const formData = new FormData();
//     formData.append("item_no", filters.itemNo);
//     formData.append("style_no", filters.styleNo);
//     formData.append("color", filters.color);
//     formData.append("po_no", filters.poNo);

//     // ✅ NEW: pass set_id
//     formData.append("set_id", filters.setId);

//     const response = await axios.post(
//       `${API_BASE_URL}${SUB_URL_KanbanPlanSheet.get_kanban_details_for_sorting}`,
//       formData
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching Kanban details for sorting:", error);
//     throw error;
//   }
// };

// // Update size quantity
// // Update size quantity
// export const updateSizeQuantity = async (kbId, sizeData) => {
//   try {
//     const formData = new FormData();
//     formData.append('kb_id', kbId);
//     formData.append('size_name', JSON.stringify(sizeData));

//     const response = await axios.post(
//       `${BASE_URL.BASE_URL}index.php/Apiv7/update_size_quantity`,
//       formData
//     );

//     return response.data;
//   } catch (error) {
//     console.error('Error updating size quantity:', error);
//     throw error;
//   }
// };

// // Set sorting to 1 for a given kb_id (Evert action)
// export const setSortingOne = async (kbId) => {
//   try {
//     const formData = new FormData();
//     formData.append('kb_id', kbId);

//     const response = await axios.post(
//       `${BASE_URL.BASE_URL}index.php/Apiv7/set_sorting_one`,
//       formData
//     );

//     return response.data;
//   } catch (error) {
//     console.error('Error setting sorting to 1:', error);
//     throw error;
//   }
// };



// src/services/KanbanPlanSheetService.js
import { apiPostForm } from "./axiosHelper";
import { SUB_URL_KanbanPlanSheet as URL } from "./BaseUrl";

// ✅ all these are v7 (unit based)
export const getActiveItems = async () => {
  const res = await apiPostForm(URL.get_active_items, {});
  return res.data; // keep same return shape as before (response.data)
};

export const getStyleNumbers = async (itemNo) => {
  const res = await apiPostForm(URL.get_style_no_by_item_no, { item_no: itemNo });
  return res.data;
};

export const getPONumbers = async (styleNo) => {
  const res = await apiPostForm(URL.get_po_no_by_style_no, { style_no: styleNo });
  return res.data;
};

export const getColors = async (poNo) => {
  const res = await apiPostForm(URL.get_color_by_po_no, { po_no: poNo });
  return res.data;
};

export const getKanbanDetailsForSorting = async (filters) => {
  const res = await apiPostForm(URL.get_kanban_details_for_sorting, {
    item_no: filters.itemNo,
    style_no: filters.styleNo,
    color: filters.color,
    po_no: filters.poNo,
    set_id: filters.setId, // ✅ NEW
  });
  return res.data;
};

// ✅ IMPORTANT: these were WRONG earlier (missing unit)
// Now they will call /apiv7/{unit}/update_size_quantity etc
export const updateSizeQuantity = async (kbId, sizeData) => {
  const res = await apiPostForm(URL.update_size_quantity, {
    kb_id: kbId,
    size_name: JSON.stringify(sizeData),
  });
  return res.data;
};

export const setSortingOne = async (kbId) => {
  const res = await apiPostForm(URL.set_sorting_one, { kb_id: kbId });
  return res.data;
};